import React, { useState, useEffect } from 'react';
import { Button, Modal, Input, message, Typography } from 'antd';
import { CopyOutlined, LinkOutlined } from '@ant-design/icons';
import { encryptUid } from '../utils/encryption';
import request from '../utils/request';

const { Text } = Typography;

// 声明 import.meta.env 的类型
declare global {
  interface ImportMetaEnv {
    VITE_APP_URL: string;
  }
}

const ReferralLinkGenerator: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [generatedLink, setGeneratedLink] = useState('');
  const [adminId, setAdminId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [adminInfo, setAdminInfo] = useState<any>(null);

  // 获取管理员信息
  useEffect(() => {
    const fetchAdminInfo = async () => {
      setLoading(true);
      try {
        console.log('Fetching admin info...');
        const response = await request.get('/admin/info');
        console.log('Admin info response:', response);
        console.log('Response code:', response.code);
        console.log('Response data:', response.data);
        
        // 检查响应是否成功（code 为 0 表示成功）
        if (response.code === 0 && response.data) {
          setAdminInfo(response.data);
          setAdminId(response.data.id);
          console.log('Admin ID set to:', response.data.id);
          console.log('Admin info set to:', response.data);
        } else {
          console.error('Invalid response:', response);
          message.error(response.message || '获取管理员信息失败');
        }
      } catch (error: any) {
        console.error('获取管理员信息失败:', error);
        message.error(error.message || '获取管理员信息失败');
      } finally {
        setLoading(false);
      }
    };

    fetchAdminInfo();
  }, []);

  // 生成推广链接
  const generateLink = async () => {
    console.log('Generating link, adminId:', adminId);
    if (!adminId) {
      message.error('未能获取管理员信息');
      return;
    }
    
    try {
      // 使用环境变量中的前端 URL，如果没有则使用默认值
      const frontendUrl = import.meta.env.VITE_APP_URL || 'https://defiportal.org';
      console.log('环境变量 VITE_APP_URL:', import.meta.env.VITE_APP_URL);
      console.log('使用的 Frontend URL:', frontendUrl);
      const encryptedId = await encryptUid(adminId.toString());
      console.log('Encrypted ID:', encryptedId);
      // 添加 main=true 参数
      const link = `${frontendUrl}?main=true&uid=${encryptedId}`;
      console.log('Generated link:', link);
      setGeneratedLink(link);
      setIsModalVisible(true);
    } catch (error) {
      console.error('生成推广链接失败:', error);
      message.error('生成推广链接失败');
    }
  };

  // 复制链接
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(generatedLink);
      message.success('链接已复制到剪贴板');
    } catch (err) {
      message.error('复制失败，请手动复制');
    }
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px 0' }}>
      <Button 
        type="primary" 
        size="large"
        icon={<LinkOutlined />}
        onClick={generateLink} 
        disabled={!adminId || loading}
        loading={loading}
      >
        生成推广链接
      </Button>

      <Modal
        title="您的推广链接"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button key="copy" type="primary" icon={<CopyOutlined />} onClick={copyLink}>
            复制链接
          </Button>,
          <Button key="close" onClick={() => setIsModalVisible(false)}>
            关闭
          </Button>
        ]}
      >
        <div style={{ marginBottom: 16 }}>
          <Input.TextArea
            value={generatedLink}
            readOnly
            autoSize={{ minRows: 2, maxRows: 4 }}
            style={{ marginBottom: 16 }}
          />
          <Text type="secondary">
            用户通过此链接访问并连接钱包后，系统将自动记录您作为推荐人
          </Text>
        </div>
      </Modal>
    </div>
  );
};

export default ReferralLinkGenerator; 